import { MinusFilled } from '@tag/tag-icons';
import { Accent } from '@tag/tag-icons/dist/accents';

import styles from './minus-icon.module.scss';

interface MinusIconProps {
  variant?: 'cancel' | 'terminate' | 'ignore';
}

export default function MinusIcon({ variant = 'terminate' }: MinusIconProps) {
  return (
    <div className={`${styles.wrapper} ${styles[variant]}`}>
      <MinusFilled accent={'red' as Accent}
      />
    </div>
  );
}
